import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";

// Dropdown needs access to the DOM node in order to position the Menu
const CustomDropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Button
      variant="secondary"
      className="text-muted"
      ref={ ref }
      onClick={(e) => {
        e.preventDefault(e);
        onClick(e);
      }}
    >
      { children }
      <FontAwesomeIcon icon={ ['fas', 'chevron-down'] } className="ml-2" />
    </Button>
  ));

  export default CustomDropdownToggle;